var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contracts-revisions-view"
  }, [(_vm.isSuccessfullyLoaded) ? _c('revision-manager', {
    attrs: {
      "fields": ['contractDuration', 'usps', 'summaryTexts', 'keywords', 'legalTexts', 'media'],
      "parent": _vm.contract,
      "revisions": _vm.contract.revisions
    },
    on: {
      "add": _vm.addRevision,
      "delete": _vm.deleteRevision,
      "edit": _vm.editRevision
    },
    scopedSlots: _vm._u([{
      key: "contractDuration",
      fn: function(contractDurationProps) {
        return [_c('inheritable-value', {
          attrs: {
            "inherited-value": _vm.contract.contractDuration,
            "value": contractDurationProps.value
          },
          scopedSlots: _vm._u([{
            key: "value",
            fn: function(ref) {
              var value = ref.value;

              return [_c('duration', {
                attrs: {
                  "value": value
                }
              })]
            }
          }])
        })]
      }
    }, {
      key: "keywords",
      fn: function(keywordsProps) {
        return [_c('inheritable-value', {
          attrs: {
            "inherited-value": _vm.contract.keywords,
            "value": keywordsProps.value
          },
          scopedSlots: _vm._u([{
            key: "value",
            fn: function(ref) {
              var value = ref.value;

              return [_c('separated-list', {
                attrs: {
                  "items": value
                }
              })]
            }
          }])
        })]
      }
    }, {
      key: "legalTexts",
      fn: function(legalTextsProps) {
        return [_c('inheritable-value', {
          attrs: {
            "inherited-value": _vm.contract.legalTexts,
            "value": legalTextsProps.value
          },
          scopedSlots: _vm._u([{
            key: "value",
            fn: function(ref) {
              var value = ref.value;

              return [_c('legal-texts-cell', {
                attrs: {
                  "legal-texts": value
                }
              })]
            }
          }])
        })]
      }
    }, {
      key: "media",
      fn: function(mediaProps) {
        return [_c('inheritable-value', {
          attrs: {
            "inherited-value": _vm.contract.media,
            "value": mediaProps.value
          },
          scopedSlots: _vm._u([{
            key: "value",
            fn: function(ref) {
              var value = ref.value;

              return [_c('gallery-cell', {
                attrs: {
                  "attachments": value
                }
              })]
            }
          }])
        })]
      }
    }, {
      key: "summaryTexts",
      fn: function(summaryTextsProps) {
        return [_c('inheritable-value', {
          attrs: {
            "inherited-value": _vm.contract.summaryTexts,
            "value": summaryTextsProps.value
          },
          scopedSlots: _vm._u([{
            key: "value",
            fn: function(ref) {
              var value = ref.value;

              return [_c('list', {
                staticClass: "uk-margin-remove",
                attrs: {
                  "items": value,
                  "type": "bullet"
                }
              }, [_c('text-placeholder', {
                slot: "empty"
              })], 1)]
            }
          }])
        })]
      }
    }, {
      key: "usps",
      fn: function(uspsProps) {
        return [_c('inheritable-value', {
          attrs: {
            "inherited-value": _vm.contract.usps,
            "value": uspsProps.value
          },
          scopedSlots: _vm._u([{
            key: "value",
            fn: function(ref) {
              var value = ref.value;

              return [_c('list', {
                staticClass: "uk-margin-remove",
                attrs: {
                  "items": value,
                  "type": "bullet"
                }
              }, [_c('text-placeholder', {
                slot: "empty"
              })], 1)]
            }
          }])
        })]
      }
    }])
  }, [_c('span', {
    slot: "title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contracts',
        params: {
          id: _vm.contract.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.contract.name))])], 1)]) : _c('div', {
    staticClass: "uk-text-center uk-margin-large uk-margin-large-top uk-margin-large-left uk-margin-large-right"
  }, [_c('loader')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f984e020","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Contracts/RevisionsView.vue
// module id = 2150
// module chunks = 0